<h1 *ngIf="content?.title">{{ content.title }}</h1>
<air-form #formComponent [controls]="form" [showMandatory]="true" (submitted)="submitValues($event)" [userEventSource]="userEventSource">
  <a (click)="submit($event)" class="button form__button button--full-width button--cta" [airButtonLoading]="isSubmitting">
    <span>{{ "account.label.save_password" | translate }}</span>
  </a>
</air-form>
<p class="form__mandatory-label">{{ "general.label.mandatory_fields" | translate }}</p>
